module.exports = __webpack_public_path__ + "img/ug535.719f2274.png";